module.exports = __webpack_public_path__ + "assets/fonts/GothamRnd-Medium.dffb2b80.otf";